module.exports = __webpack_public_path__ + "img/fireworks-animation.9598673b.png";